module.exports = {
    generateFirmwareFileKey: function (name, model, checksum) {
        return `${model}/${name}_${checksum}.bin`;
    },
    generateInformationFileKey: function (model) {
        return `${model}/rayz_info.json`;
    },
    generateReleaseNotesFileKey: function (model) {
        return `${model}/release_notes.json`;
    },
    generatePublishLogKey: function (model, version) {
        return `published/${model}/${version}_log.json`;
    },
    generateBuildFileKey: function (buildName) {
        return `build/${buildName}/${buildName}.bin`;
    },
    generateResourceFile1Key: function (buildName) {
        return `build/${buildName}/${buildName}_resource1`;
    },
    generateResourceFile2Key: function (locale, checksum, version) {
        return `resource2/${locale}_${checksum}_${version}`;
    },
    generateNotificationFileKey: function(prefix, locale) {
        return `notification/${prefix}/${locale}_alert.json`;
    }
};
